import React from 'react';
import { motion } from 'framer-motion';
import { FaPhone, FaCalendarCheck, FaCar, FaUserCheck, FaClock } from 'react-icons/fa';
import { COMPANY_PHONE_DISPLAY, COMPANY_PHONE_TEL } from '../constants';

const WhatToExpect = ({ onBookClick }) => {
  const steps = [
    {
      icon: <FaPhone size={40} />,
      title: "1. Book Your Ride",
      description: `Call our dispatch at ${COMPANY_PHONE_DISPLAY} or use our online quote request form. Provide your pickup location, destination, date, time, and any special requirements. Our team will confirm your booking and provide an estimated arrival time.`
    },
    {
      icon: <FaCalendarCheck size={40} />,
      title: "2. Confirmation",
      description: "You'll receive confirmation of your booking with all the details. For recurring appointments, we can set up a regular schedule. If you need to make changes, just call us at least 2 hours in advance when possible."
    },
    {
      icon: <FaCar size={40} />,
      title: "3. Pickup Day",
      description: "Our driver will arrive at your scheduled pickup time. They'll assist you to the vehicle, help with any mobility aids, and ensure you're comfortably seated. All our drivers are trained in passenger assistance and wheelchair securement."
    },
    {
      icon: <FaUserCheck size={40} />,
      title: "4. During Transport",
      description: "Enjoy a safe, comfortable ride to your destination. Our drivers are professional, courteous, and focused on your safety. They'll help you exit the vehicle and assist you to your destination entrance if needed."
    },
    {
      icon: <FaClock size={40} />,
      title: "5. Return Trip",
      description: "If you've scheduled a return trip, our driver will pick you up at the designated time. For appointments, we coordinate with facilities to ensure timely pickup. Just let us know when you're ready, and we'll dispatch your return ride."
    }
  ];

  const tips = [
    "Be ready 10-15 minutes before your scheduled pickup time",
    "Inform us of any mobility aids or special equipment you'll need",
    "Bring contact information for your destination",
    "Call us if your appointment time changes"
  ];

  return (
    <section className="what-to-expect" id="what-to-expect">
      <div className="container">
        <motion.div
          className="expect-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>What to Expect</h2>
          <p>Understanding our process helps ensure a smooth experience. Here's what happens from booking to drop-off.</p>
        </motion.div>

        <div className="process-steps">
          {steps.map((step, index) => (
            <motion.div
              className="process-step"
              key={index}
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="step-icon">{step.icon}</div>
              <div className="step-content">
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="tips-section"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
        >
          <h3>Helpful Tips for Your Ride</h3>
          <ul className="tips-list">
            {tips.map((tip, index) => (
              <li key={index}>{tip}</li>
            ))}
          </ul>
        </motion.div>

        <motion.div
          className="expect-cta"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <p>Ready to book your ride? Our friendly dispatch team is here to help.</p>
          <div className="cta-buttons">
            <button onClick={onBookClick} className="cta-button">Request a Quote</button>
            <a href={`tel:${COMPANY_PHONE_TEL}`} className="cta-button-secondary">Call {COMPANY_PHONE_DISPLAY}</a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default WhatToExpect;

